import React, { useEffect, useRef } from 'react'
import "./TeamDetails.css"
import Header from '../../Components/Header'
import MeetTeam from '../MeetTeam'
import Footer from '../../Components/Footer'
// import team1 from '../../Assets/doctor.jpg';
import bgimage1 from "../../Assets/service1.webp"
import joshma from '../../Assets/joshma.jpg';
import diksha from '../../Assets/diksha.jpg';
const TeamDetails = () => {
     const scrollContainerRef = useRef(null);
useEffect(()=>{
 window.scrollTo(0,0)
},[])
  const founders = [
    {
      id: 1,
      name: 'Ms. Joshma Choudhury',
      position: 'Founder ',
      image: joshma,
      backgroundImage: bgimage1,
      description: [
        'Ms. Joshma Choudhury is a seasoned professional with a diverse background spanning aviation and special education. She has been associated with British Airways and has extensive experience in Autism Spectrum Disorder (ASD) education.',
        'She holds a Master’s degree in Mass Communication from the University of Culture and has completed multiple diplomas in special education from premier institutes. Her multidisciplinary expertise enables her to bring a unique perspective to both communication and inclusive education.',
      ]
    },
    {
      id: 2,
      name: 'Ms. Diksha Choudhury',
      position: 'Co-Founder ',
      image: diksha,
      backgroundImage: bgimage1,
      description: [
        'Ms. Diksha Choudhury is currently pursuing an Integrated Law Programme at NMIMS University, Mumbai. She is actively involved in assisting the CBGE team in strategic operations across various projects within the legal domain.',
        'Her academic background, combined with hands-on experience in legal and operational work, reflects her strong commitment to building impactful and well-structured initiatives.'
      ]
    }
  ];

  // const teamMembers = [
  //   {
  //     id: 1,
  //     name: 'Gautam Mohanty',
  //     position: 'Director - EPC ProjectS',
  //     description:"Gautam Mohanty is a highly qualified engineering project lead with over 25 years of experience with Essar Steel, Essar Power, Essar Projects, spanning across the Middle East, India and South East Asia.",
  //     image: team1
  //   },
  //   {
  //     id: 2,
  //     name: 'Suraj Gantayat',
  //     position: 'Chief Technology Officer',
  //     description:"Suraj Kumar Gantayat is a CEO, investor, and conservationist with multiple roles in various companies and organizations.",
  //     image: team1
  //   },
  //   {
  //     id: 3,
  //     name: 'Subrat Kumar Satpathy',
  //     position: 'Director - Business Development',
  //     description:"Subrat Kumar Satpathy has over 21 years of experience across sectors like Banking, Insurance and Remittances, Government and Social Development.",
  //     image: team1
  //   },
  //   {
  //     id: 4,
  //     name: 'Swapnendu Kabi',
  //     position: 'Director - Operations',
  //     description:"Swapnendu Kabi is seasoned Corporate, Government & Public affairs professional. He has worked with Eli Lilly, PepsiCo India, Reliance Telecom, Essar and Essel Group (Non Media). He has more than 20 years of experience managing environment across states with diverse political ideologies & social customs/cultures.",
  //     image: team1
  //   }
  // ];
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = container.offsetWidth / 4 + 30; // One card width + gap
      const targetScroll = direction === 'left' 
        ? container.scrollLeft - scrollAmount 
        : container.scrollLeft + scrollAmount;
      
      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  };
  return (
    <>
    <Header/>
      
      {/* Hero Section */}
      <section className='team-details-hero'>
        <article className='team-details-hero-gap'>
          <div className='team-details-texts'>
            <h1 className='team-details-head-text'>
             Our Founders &  <br />Core Team
            </h1>
            <p className='team-details-sub-text'>
           A strong leadership foundation supported by experienced teams,
  <br />delivering excellence through collaboration and innovation.
            </p>
          </div>
        </article>
      </section>
   {/* =========== our team =================== */}
   <section className="meet-team-section">
      <div className="meet-team-container">
        {/* Header */}
        <div className="meet-team-header">
          <span className="meet-team-badge">Meet the Founders and Team</span>
          <h1 className="meet-team-title">
            Experts Driving Your <br />
            Project Success
          </h1>
          <p className="meet-team-subtitle">
            Our team brings together decades of experience in land acquisition, legal compliance, and community engagement to deliver exceptional results.
          </p>
        </div>

        {/* Founders Section */}
        <div className="founders-section">
          {founders.map((founder, index) => (
            <div key={founder.id} className={`founder-card ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
            style={{
                backgroundImage: `url(${founder.backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center 85%',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <div className="founder-image-wrapper">
                <img 
                  src={founder.image} 
                  alt={founder.name} 
                  className="founder-image"
                />
              </div>
              <div className="founder-content">
                <h3 className="founder-name">{founder.name}</h3>
                <p className="founder-position">{founder.position}</p>
                <div className="founder-description">
                  {founder.description.map((para, index) => (
                    <p key={index} className="founder-para">{para}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Team Grid Wrapper with Scroll */}
        {/* <div className="meet-team-scroll-wrapper">
          <div 
            className="meet-team-grid"
            ref={scrollContainerRef}
          >
            {teamMembers.map((member) => (
              <div key={member.id} className="meet-team-card" data-aos="fade-up">
                <div className="meet-team-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="meet-team-image"
                    draggable="false"
                  />
                  <div className="meet-team-overlay">
                    <div className="meet-team-info">
                      <h3 className="meet-team-name">{member.name}</h3>
                      <p className="meet-team-position">{member.position}</p>
                      <p className="text-light" style={{fontSize:"13px",fontWeight:"100",color:"white",opacity:".7"}}>{member.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Scroll Buttons */}
        {/* <div className="meet-team-scroll-buttons">
          <button 
            className="meet-team-scroll-btn meet-team-scroll-left"
            onClick={() => scroll('left')}
            aria-label="Scroll left"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button 
            className="meet-team-scroll-btn meet-team-scroll-right"
            onClick={() => scroll('right')}
            aria-label="Scroll right"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div> */}

      </div>
    </section>
      <Footer/>
    </>
  )
}

export default TeamDetails